

import { defineComponent } from 'vue';
import { mapState, mapStores } from 'pinia';
import { NTabs, NTabPane } from 'naive-ui';
import moment from 'moment';

import StationList from '~/components/station-list/station-list.vue';
import GroupList from '~/components/group-list/group-list.vue';

import { useStationStore } from '~/store/station.store';
import { useDashboardStore } from '~/store/dashboard.store';

import { Station } from '~/api/models/station.model';
import WidgetContentBase from '~/components/widgets/widget-content-base';
import { fake } from './widget-station-list-fake';

export default defineComponent({

    extends: WidgetContentBase,

    components: {
        StationList,
        GroupList,
        NTabs,
        NTabPane,
    },

    computed: {
        ...mapStores(useDashboardStore),
        ...mapState(useStationStore, ['stations', 'groups']),
        ...mapState(useDashboardStore, ['currentStation']),


        stationList(): Station[] {
            return this.fake ? fake : (this.stations || []);
        },

        station(): Station {
            return this.fake ? this.stationList[0] : this.currentStation;
        }
    },

    methods: {
        onStationForgotten(station: Station): void {
            if(this.editable) {
                return;
            }
            
            this.$router.replace({ path: this.$route.path, query: { station: this.stations[0]?.id } });
        },

        refresh(): void {
            console.log('widget-station-list');
            this.dashboardStore.refresh();
        }
    }
});

